/**
 * NZSC-4145: 하단 네비 매매보증 탭 목적지 판정 — web-core src/lib/insurance/firstamGuaranteeRoute.ts 와 같은 규칙.
 *  - 로그인했고 이용이 끝나지 않은 가입 건(거절·취소·철회 제외)이 있으면 → 가입 내역
 *  - 그 외 → 랜딩
 * 두 목적지 모두 web-core 화면이라 router.push 하면 중앙 가드(WEB_CORE_MIGRATED_ROUTES)가 풀 로드로 넘긴다.
 * 진입점은 ?from=gnb 로 실어 랜딩·가입 내역 view 이벤트에 남긴다.
 */
import { FIRSTAM_LANDING_ENTRY, FIRSTAM_LANDING_PATH } from "@/utils/firstamLandingEntry";

export const FIRSTAM_MY_PATH = "/insurance/firstamerican/title-001/my";

export function fnGuaranteeDestination(loggedIn, ongoingAppCount) {
  return loggedIn && ongoingAppCount > 0 ? "my" : "landing";
}

/** 라우터 location — Vue 에서 보내는 진입점은 하단 네비(gnb) 하나다 */
export function fnGuaranteeLocation(destination) {
  return {
    path: destination === "my" ? FIRSTAM_MY_PATH : FIRSTAM_LANDING_PATH,
    query: { from: FIRSTAM_LANDING_ENTRY.GNB },
  };
}
